import type { SanityPageBuilderMediaCarouselSection, SanityPageBuilderMediaCarouselSlide, SanityPageBuilderSection } from "@ouster/shared";
import { MediaCarouselBlockView } from "~/features/blocks/inventory/media-carousel";
import { useMediaQuery } from "~/features/ui/use-media-query";
import { up } from "~/features/app/screens";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderMediaCarouselSection;
  };
};
export function SanityMediaCarouselSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const slides = sectionContent.slides?.filter(slide => hasRenderableSanityMedia(slide.media)) ?? [];
  const isLg = useMediaQuery(up("lg"));
  const mode = sectionSettings?.mode || "light";
  const theme = sectionSettings?.theme || "white";
  return <MediaCarouselBlockView<SanityPageBuilderMediaCarouselSlide> anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getSlideKey={(slide, index) => slide._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={mode} renderSlide={slide => <SanityMediaFigure media={slide.media} ratio={isLg ? undefined : "5/6"} height={isLg ? 520 : undefined} sizes="lg:50vw" />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} slides={slides} theme={theme} />;
}